import React from "react";
import { Check } from "lucide-react";

interface CheckboxProps {
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  className,
}) => {
  return (
    <div className={`flex items-start gap-2 ${className}`}>
      <div
        className={`w-5 h-5 rounded-sm flex items-center justify-center cursor-pointer ${
          checked
            ? "bg-[var(--app-primary)] border border-[var(--app-primary)]"
            : "bg-white border border-[var(--app-primary)]"
        }`}
        onClick={() => onChange(!checked)}
      >
        {checked && <Check className="w-4 h-4 text-white" />}
      </div>
      <label
        htmlFor="checkbox"
        className="text-sm text-[var(--text-secondary)]"
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
